import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const FormSelect = ({ options, value, onChange, creatable, classNamePrefix, isMulti, placeholder, title, isDisabled }) => {
  const CustomSelect = creatable ? CreatableSelect : Select;
  return (
    <>
      <CustomSelect
        options={options}
        value={value}
        onChange={onChange}
        classNamePrefix={classNamePrefix}
        isClearable
        isSearchable
        menuPosition="fixed"
        isMulti={isMulti}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
      {!isDisabled && <label className="select__label">{title}</label>}
    </>
  );
};

export default FormSelect;
